import modalService from 'layout/services/modalService';
import { checkCircleFilledIconSvg } from 'constants/svg-assets';
import { closeModalSvg } from '../constants/svgIcons';

/**
 * Post-submit confirmation screen for the "Get more information" flow (NHS20-8178) — shown after
 * GetMoreInformationForm posts successfully, selected via ThankScreenVariation.Information.
 */
export default class ThankScreenInformation {
  constructor(modalInformation) {
    this.builderName = modalInformation?.brandName ?? 'the builder';
    this.closeAttribute = '[data-close]';
  }

  bindEvents() {
    const closeElements = document.querySelectorAll(this.closeAttribute);
    closeElements.forEach((element) => element.addEventListener('click', ThankScreenInformation.closeModal));
  }

  unbindEvents() {
    const closeElements = document.querySelectorAll(this.closeAttribute);
    closeElements.forEach((element) => element.removeEventListener('click', ThankScreenInformation.closeModal));
  }

  static closeModal() {
    modalService.clearHtml();
  }

  getHtml() {
    return `
    <div>
      <div class="nhs-o-flex-row-items-center nhs-u-gap--200 nhs-u-padding--600">
        <div class="nhs-u-flex--1-0-0"></div>
        <button type="button" class="nhs-n1-c-button__modal-close nhs-n1-c-button__modal-close--transparent" data-close aria-label="Close modal">
          ${closeModalSvg}
        </button>
      </div>
      <div class="nhs-o-flex-column-items-center nhs-u-gap--600 nhs-u-padding--0-600-600">
        <div class="nhs-o-flex-row-items-center-justify-center nhs-u-width--full">
          <div class="nhs-n1-c-badge__status--success">
            ${checkCircleFilledIconSvg}
          </div>
        </div>
        <div class="nhs-o-flex-column-items-center nhs-u-gap--500 nhs-u-text--align-center">
          <p class="nhs-o-typography--souvenir-heading-1-extra-large-light">Request sent!</p>
          <p class="nhs-o-typography--sans-body-1-medium-regular">${this.builderName} will be in touch with you shortly.</p>
        </div>
      </div>
    </div>`;
  }
}
